<template>
  <container style='height: 450px;'>
    <div class="barCharts">
      <div class="nav-scroll">
        <span class="left">资产数量</span>
        <span style="color:#B8D7FF;">
          管理资产总数 {{staticData.assetTotal}}
        </span>
      </div>
      <div class="bar fl">
        <!-- 资产柱状图 -->
        <div class="title">
          {{title}}
        </div>
        <div :id="id" style="height:300px;"></div>
        <noData   v-if='nodata' style='position: absolute;left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);'/>
      </div>
      
    </div>
    
  </container>
</template>

<script>
  import noData from "../../index/components/noData";
  import container from "../../index/components/container";
  import {getAssetStatistics} from '@/api/asset.js'
  import echarts from 'echarts'
  import {mapState} from 'vuex'
  export default {
    name: "bar",
    props: {
      title: String,
      data: Array,
    },
    components: {
      container,
      noData
    },
    data() {
      return {
        id: "bar" + Math.random(),
        flag: true,
        staticData:{},
        nodata:false,
      }
    },
    watch: {
      data: function () {
        let data = this.data
        if (!this.flag) {
          return false
        }
        this.nodata=!this.data.length
        let legendData=[]
        let legendNum=[]
        for (let i = 0; i < data.length; i++) {
            legendData.push(data[i].companyName)
            legendNum.push(data[i].companyId)
        }
        this.$nextTick(function () {
          this.flag = false
          var myChart = echarts.init(document.getElementById(this.id));
          let option = {
            color: ['#3398DB'],
            tooltip: {
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            grid: {
                left: '2%',
                right: '2%',
                bottom: '3%',
                containLabel: true,
            },
            dataZoom: [
              {
                type: 'slider',
                xAxisIndex: [0],
                show: legendData.length<=6 ? false : true,
                startValue:0,
                endValue:6,
                borderColor: 'rgba(255,255,255,0)',
                backgroundColor:"rgba(255,255,255,0)",
                dataBackground:{
                  lineStyle:{
                    color:'rgba(255,255,255,0)',
                    width:'0',
                  },
                  areaStyle:{
                    color:'rgba(255,255,255,0)',
                  },
                },
                handleSize:"0",
                textStyle:{
                  color:"rgba(255,255,255,0)"
                },
                bottom:"-23",
              },
              {
                type: 'inside',
                zoomOnMouseWheel:false,
                moveOnMouseWheel:true,
                show: legendData.length<=6 ? false : true,
                xAxisIndex: [0],
                start: 1,
                end: legendData.length<=6 ? 100 : 40
              },
            ],
            xAxis: {
                type: 'category',
                data: legendData,
                color:'#B8D7FF',
                axisTick: {
                  alignWithLabel: true,
                },
                axisLine: {
                    lineStyle: {
                        color: '#1D3E8F' //坐标轴线线的颜色。
                    }
                },
                axisLabel:{
                  margin: 20, //刻度标签与轴线之间的距离
                  textStyle: {
                      fontSize: 12 ,//文字的字体大小
                      color: '#B8D7FF',
                  },
                  formatter : function(params){
                    var newParamsName = "";// 最终拼接成的字符串
                    var paramsNameNumber = params.length;// 实际标签的个数
                    var provideNumber = 8;// 每行能显示的字的个数
                    var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
                    /**
                     * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                     */
                    // 条件等同于rowNumber>1
                    if (paramsNameNumber > provideNumber) {
                      /** 循环每一行,p表示行 */
                      for (var p = 0; p < rowNumber; p++) {
                        var tempStr = "";// 表示每一次截取的字符串
                        var start = p * provideNumber;// 开始截取的位置
                        var end = start + provideNumber;// 结束截取的位置
                        // 此处特殊处理最后一行的索引值
                        if (p == rowNumber - 1) {
                          // 最后一次不换行
                          tempStr = params.substring(start, paramsNameNumber);
                        } else {
                          // 每一次拼接字符串并换行
                          tempStr = params.substring(start, end) + "\n";
                        }
                        newParamsName += tempStr;// 最终拼成的字符串
                      }

                    } else {
                      // 将旧标签的值赋给新标签
                      newParamsName = params;
                    }
                    //将最终的字符串返回
                    if(newParamsName.length>12){
                      return newParamsName.substr(0,12)+'...'
                    }else{
                      return newParamsName
                    }
                  }
                },
            },
            yAxis: [{
                type: 'value',
                minInterval: 1,
                axisLine:{
                  lineStyle:{
                    opacity:0,
                  },  
                },
                axisLabel: {
                    margin: 20, //刻度标签与轴线之间的距离
                    textStyle: {
                        fontSize: 12 ,//文字的字体大小
                        color: '#B8D7FF',
                    }
                },
                textStyle:{
                  fontSize:25,
                  color:'#B8D7FF',
                },
                axisTick:{
                  show: false,
                },
                splitLine: {
                    show: true,
                    lineStyle:{
                        type:'dashed',
                        color:'#1D3E8F',
                    }, 
                },
            }],
            series: [{
                name: '资产数量',
                type: 'bar',
                barWidth: 50,
                data: legendNum,

            }]
            
          };

          myChart.setOption(option);
          // myChart.on('click', function(params) {
          //   //为三个柱子设置点击事件
          //   var name = params.name;
          //   if (params.componentType == "xAxis") {
          //       alert("单击了" + params.value + "x轴标签");
          //   } else {
          //       alert("单击了" + params.name + "柱状图");
          //   }
          // });
        })
      }
    },
    methods: {
      getStatic(){
        getAssetStatistics({companyId:this.user.companyId}).then(res=>{
          let data=res.data;
          if(data.code==='000'){
            this.staticData=data.content.assetStatistics;
          }else{
            console.log(data.desc)
          }
        })
      },
    },

    created() {
      this.getStatic()
    },
    mounted() {

    },
    computed: {
      ...mapState({
        user:state=>state.user.user
      })
    }
  }
</script>

<style lang="scss">
.barCharts{
  .nav-scroll {
    border-bottom: 1px solid #1D3E8F !important;
  }
}
</style>
<style scoped lang="scss">
.barCharts{
  .nav-scroll {
    margin: 0 25px;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    height: 51px;
    line-height:51px;
    border-bottom: 1px solid #1D3E8F !important;
    .left {
      color: #1D3E8F;
      border-bottom: 1px solid #4F85FF;
    }
  }
  .bar {
    width: 100%;
    background-color: #061033;
    
    .title {
      font-size: 14px;
      color: #B8D7FF;
      font-weight: 700;
      width: 600px;
      padding-left:24px;
      padding-top: 30px;
    }
    
  }
}
  
</style>
